<template>
  <div v-if="fetching">
    <Skeleton class="h-[65vh] max-h-[1330px] min-h-[550px]" />
    <div class="mx-3.5 mt-12 sm:mx-auto sm:w-1/2">
      <Skeleton />
    </div>
    <div
      class="mx-3.5 mt-12 grid grid-cols-2 gap-8 sm:mx-5 sm:grid-cols-5 sm:gap-24"
    >
      <Skeleton class="aspect-1" type="custom" full-width />
      <Skeleton class="aspect-1" type="custom" full-width />
      <Skeleton class="aspect-1" type="custom" full-width />
      <Skeleton class="aspect-1" type="custom" full-width />
      <Skeleton class="aspect-1" type="custom" full-width />
    </div>
  </div>
  <div v-else data-test-id="home-page-content" class="mx-3.5 sm:mx-5">
    <KeepAlive>
      <Story v-if="data" :story="data" />
    </KeepAlive>
    <TopCategories />
  </div>
</template>

<script setup lang="ts">
import { defineOptions, computed } from 'vue'
import { useCurrentShop } from '#storefront/composables'
import { useRuntimeConfig } from '#app/nuxt'
import { definePageMeta } from '#imports'
import { createError } from '#app/composables/error'
import { fetchOnNavigation } from '#layers/base/utils/loading'
import useStoryMetaData from '~/composables/useStoryMetaData'
import useStaticMetaLinks from '#layers/base/composables/useStaticMetaLinks'
import useCms from '~/composables/cms/useCms'
import type { SbPage } from '~/cms/storyblok/types/storyblok.d.ts'

const { fetchBySlug, data, fetching, excluded } = useCms<SbPage>('home')

const metaLinks = useStaticMetaLinks('')
const config = useRuntimeConfig()
const currentShop = useCurrentShop()

const metaDataExtensions = computed(() => ({
  link: metaLinks.value,
}))

const metaDataOverrides = computed(() => ({
  canonical: `${config.public.baseUrl}/${currentShop.value.locale}`,
}))

useStoryMetaData({
  data,
  fetching,
  extensions: metaDataExtensions,
  overrides: metaDataOverrides,
})

useRouteCache((helper) => {
  helper.setMaxAge(3600).setCacheable()
})

await fetchOnNavigation(async () => {
  await fetchBySlug('home')
  if (excluded.value || !data.value) {
    throw createError({ statusCode: 404, statusMessage: 'Not found' })
  }
})

defineOptions({ name: 'HomePage' })
definePageMeta({ pageType: 'home' })
</script>
